import React from 'react';
import { Doughnut } from 'react-chartjs-2';
import { InformationTitle, Numbers } from '../../../CampaignDetails/CampaignDetails.styles';
import { CircleDiagramProps } from './CircleDiagram.interface';
import {
    Wrapper,
    Color,
    ItemWrapper,
    DoughnutWrapper
} from './CircleDiagram.styles';
import { CircleDiagramOptions } from './CircleDiagramOptions';

export function CircleDiagram({ 
        title, 
        showVotes, 
        diagramColors, 
        diagramData, 
        diagramLabels 
    }: CircleDiagramProps) {

    const circleData = {
        labels: diagramLabels,
        datasets: [
            {
                data: diagramData,
                backgroundColor: diagramColors
            }
        ]
    }
    const totalVotes = diagramData.length > 0 ? diagramData.reduce((a, b) => a + b) : 0;
    return (
        <>
            <InformationTitle>{title}</InformationTitle>
            <DoughnutWrapper center={showVotes}>
                <div style={{width: 200}}>
                    <Doughnut 
                        data={circleData}
                        options={CircleDiagramOptions}
                    />
                </div>
                {showVotes &&
                    <div>
                        <InformationTitle>Total number of votes</InformationTitle>
                        <Numbers>{totalVotes}</Numbers>
                    </div>
                }
            </DoughnutWrapper>
            <div>
                {circleData.labels.map((name, index)=> (
                    <ItemWrapper key={index}>
                        <Wrapper>
                            <Color color={circleData.datasets[0].backgroundColor[index]}/>
                            <p>{name}</p>
                        </Wrapper>
                        <div>
                            <span>
                                ~{totalVotes === 0 ? '0%' : Math.floor(circleData.datasets[0].data[index]*100/totalVotes)+'%'}
                            </span>
                        </div>
                    </ItemWrapper>
                ))}
            </div>
        </>
    )
}
